<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">
    <z-page :title="title">
    <div class="w-card__content content-hardcode">
    <div class="w-flex wrap smd-column" >
      <div class="grow " >
        <w-select class="mt4" outline :items="premis" label="ID / Nama Premis *"  v-model="form.premis_id" @input="getTernakan(form)" :validators="[validators.required]"/>
        &nbsp;
        <w-select class="mt4" outline :items="lkp_ternakan" label="Jenis Ternakan *"  v-model="form.lkp_ternakan_id" @input="getTernakan(form)"  :validators="[validators.required]"/>
        &nbsp;&nbsp;
        <div class="w-flex wrap smd-column" >
            <div class="grow " >
                <div style="margin:5px;" class="fw-normal my1 fs-1"><b> PASUNG : </b><w-radios
                      class="mr2"
                      v-model="form.pasung"
                      :items="pasung_list"
                      inline
                      color="blue-light1">
                    </w-radios></div>
                </div>
              </div>
        </div>
        <div class="mx2"></div>
          <div class="grow " >
              <w-select class="mt4" outline :items="jantina" label="Jantina *" @input="getTernakan(form)" v-model="form.jantina"  :validators="[validators.required]"/>
              &nbsp;
              <w-select class="mt4"  outline :items="pemeriksa" label="Nama Pegawai Pemeriksa*" v-model="form.pemeriksa_id"  :validators="[validators.required]"/>
       </div>     
      </div>
    </div>
    <br>
    <div class="w-table-wrap" style="max-height: 400px;">
      <div class="table-profil-scrol">
        <table class="w-table" color="light" >
          <thead>
            <tr>
              <th class="w-table__header  text-left" width="1%">BIL</th>
              <th class="w-table__header  text-left">NO PENDAFTARAN</th>
              <th class="w-table__header  text-left">ID / NAMA TERNAKAN</th>
              <th class="w-table__header  text-left">JENIS TERNAKAN</th>
              <th class="w-table__header  text-left">JANTINA</th>
              <th class="w-table__header  text-left">BAKA</th>
              <th class="w-table__header  text-left">UMUR (BULAN)</th>
              <th class="w-table__header  text-left">BILANGAN PEMERIKSAAN</th>
              <th class="w-table__header  text-left">TARIKH AKHIR PEMERIKSAAN</th>
              <th class="w-table__header  text-left">SILA PILIH TERNAKAN YANG HENDAK DIPERIKSA</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="ternakan_list.length == 0">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" colspan="9"> Tiada Data.</td>
              </tr>
            </template>
            <template v-for="(dt, ind) in ternakan_list">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" >{{ind+1}}</td>
                <td class="w-table__cell text-left" >{{dt.kode}}</td>
                <td class="w-table__cell text-left" >
                    <span v-if="dt.id_ternakan != null">{{dt.id_ternakan}}</span>
                    <span v-else>{{dt.nama}}</span>
                </td>
                <td class="w-table__cell text-left" >{{dt.ternakan}}</td>
                <td class="w-table__cell text-left" >{{dt.jantinas_label}}</td>
                <td class="w-table__cell text-left" >{{dt.baka}}</td>
                <td class="w-table__cell text-left" >{{$zutil.umurBln(dt.tarikh_lahir)}}</td>
                <td class="w-table__cell text-left" >{{dt.bil_pemeriksaan}}</td>
                <td class="w-table__cell text-left" >{{$zutil.dateformat(dt.tarikh_pemeriksaan)}}</td>
                <td class="w-table__cell text-center"><div class="title4 mb2"></div><w-checkbox v-model="dt.pilih" ></w-checkbox>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        </div>
      </div>
      <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '2', '5'])">
        <w-button class="my1"   :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
        </w-button>
        &nbsp;
        <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
          <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
        </w-button>
      </w-flex>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
  </z-page>
    </w-form>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id: [Array, Object],
    d_form: [Array, Object],
    d_lkp_negeri: [Array, Object]
  

  },
  data() {
    return {
      resourceurl: 'pdbf.permohonan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Penilaian Daya Biak & Fertiliti', route: '/pdbf' },
        { label: 'Permohonan PDBF', route: '/pdbf/permohonan' },
        { label: 'Form', route: '/pdbf/permohonan' },
      ],
      negeri : '',
      title : 'PDBF  Permohonan',
      form : this.d_form,
      lkp_negeri : this.d_lkp_negeri,
      ternakan_list:[],
      premis : [],
      pemeriksa : [],
      lkp_ternakan : [],
      lkp_status : [],
      jantina : [],
      pasung_list:[
        {value: 1, label: "ADA"},
        {value: 2, label: "TIADA"},
      ],
      loading : 0,
      checkin:false,
    
    }
  },
  methods: {
    send(hantar){
      this.form.hantar = hantar
    },

    klickPilih(){
        for (var b in this.ternakan_list) {
            this.ternakan_list[b].pilih = this.checkin
        }
    },
    onSuccess(){
      this.form.ternakan_list = this.ternakan_list;
      if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              
              if (this.form.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  if (this.form.hantar==1) {
                      this.$inertia.visit(this.$route('pdbf.permohonan.index', this.form.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }else{
                this.$zcomm.post(this.resourceurl+'.store' , this.form)
                .then(res => {
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd()
                  }
                  this.$zutil.notify("Berjaya dihantar", true);
                  this.$inertia.visit(window.route('pdbf.permohonan.index',res.id));

                })
              }
            }
          })
      }else{
        if (this.form.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('pdbf.permohonan.index'));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('pdbf.permohonan.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
        else 
        {
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('pdbf.permohonan.index', res.id));

          })
        }
      } 
      
    },

    getPremis(){
      this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
        this.premis = res
      })
    },

    getData(){
      this.getTernakan(this.d_form);
    },

    getTernakan(data){
      // alert(form.jantina);
      if(data.premis_id !='' && data.lkp_ternakan_id !='' && data.jantina !=''){
        this.$zcomm.get(this.api_service + 'pdbf/ternakan_pdbf/'+data.premis_id+'/'+data.lkp_ternakan_id+'/'+data.jantina, {}).then(res => {
          this.ternakan_list = res
          if(data.ternakan_list.length > 0){
            for (var i in this.ternakan_list) {
              for (var t in data.ternakan_list) 
              {
                if(this.ternakan_list[i].ternakan_id == data.ternakan_list[t].ternakan_id){
                  
                  this.ternakan_list[i].pilih = true
                }
              }
            }

          }
        })

      }
      for (var b in this.premis) 
      {
        if(this.premis[b].value == data.premis_id){
          this.form.lkp_negeri_id = this.premis[b].lkp_negeri_id;
          this.form.lkp_negeri = this.premis[b].lkp_negeri;
        }
      }
      
    },



    getJuruteknik(data){
      if(data.lkp_negeri_id !='' && data.lkp_art_id !='' ){
        this.$zcomm.get(this.api_service + 'lookup/juruteknik/'+data.lkp_negeri_id+'/'+data.lkp_art_id, {}).then(res => {
          this.juruteknik_list = res
        })
      }
    },

    getJenisTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },

    getJantina(){
      this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
        this.jantina = res
      })
    },

    getJantina(){
      this.$zcomm.get(this.api_service + 'lookup/jantinas', {}).then(res => {
        this.jantina = res
      })
    },

    getPemeriksa(){
         this.$zcomm.get(this.api_service + 'lookup/pemeriksa', {}).then(res => {
           this.pemeriksa = res
         })
       },


     tutup(){
         this.$inertia.visit(window.route('pdbf.permohonan.index'));
       },




  },

  watch: {
    premis: {
        handler(newVal) {
        if (newVal.length === 1) {
            this.form.premis_id = newVal[0].value;
            this.getTernakan(this.form);
        }
        },
        immediate: true,
    },
    lkp_ternakan: {
        handler(newVal) {
        if (newVal.length === 1) {
            this.form.lkp_ternakan_id = newVal[0].value;
            this.getTernakan(this.form);
        }
        },
        immediate: true,
    },
  },
  mounted() {
    var today = new Date();
    this.tarikh_today = today.toISOString().split('T')[0];
    if(this.id > 0)
    {
      this.title = 'Tambah Permohonan Perkhidmatan Penilaian Daya Biak & Fertiliti'
    }
    else
    {
      this.title = 'Tambah Permohonan Perkhidmatan Penilaian Daya Biak & Fertiliti'
    }
    this.getPremis()
    this.getJenisTernakan()
    this.getData()
    this.getPemeriksa()
    this.getJantina()
    // this.getTernakanList()
  }
    
}
</script>
